export interface ModelMarker {
  id: number; // int
  name: string; // string
}

export interface Value {
  value: ModelMarker[];
  '@odata.context'?: string | undefined;
  '@odata.count'?: number | undefined;
}

// init api object
function toAPI(data: Partial<ModelMarker>): any {
  return {
    Id: data?.id || 0,
    Name: data?.name || '',
  };
}

function parse(data?: Partial<ModelMarker>): ModelMarker {
  return {
    id: data?.id || 0,
    name: data?.name || '',
  };
}

export default {
  parse,
  toAPI: toAPI,
};
